import { makeDoubleArgHook } from "../../utils/makeDoubleArgHook";
import { getPortfolioPlanById, PortfolioPlanByIdResponse, portfolioPlanByIdURL, PortfolioPlanResponse, stringifyQueryParams, } from "../request/getPortfolioPlanById";
import { ALL_PORTFOLIOS } from "./constants";
export { PortfolioPlanResponse as PortfolioPlan, PortfolioPlanByIdResponse };
export function portfolioPlanByIdKeyMaker(portfolioPlanId, params) {
    if (params === null) {
        return [
            portfolioPlanByIdURL(ALL_PORTFOLIOS),
            portfolioPlanByIdURL(portfolioPlanId),
        ];
    }
    return [
        portfolioPlanByIdURL(ALL_PORTFOLIOS),
        portfolioPlanByIdURL(portfolioPlanId),
        stringifyQueryParams(params),
    ];
}
const useGetPortfolioPlanById = makeDoubleArgHook(getPortfolioPlanById, (portfolioId, params) => portfolioPlanByIdKeyMaker(portfolioId, params));
export default useGetPortfolioPlanById;
//# sourceMappingURL=useGetPortfolioPlanById.js.map